<template>
  <div class="settlement-detail-head">
    <div class="b-2-f0 p-20 flex-ac flex-h-sb">
      <span class="f-14 c-3">
        结算状态：
        <span :style="data.status | convertStatusTag">{{ data.status | convertStatus }}</span>
      </span>
      <el-button size="mini" type="primary" plain @click="exportDetail">导出结算明细</el-button>
    </div>
    <div class="b-2-f0 p-20 m-t20 f-14 c-3">
      <el-row>
        <el-col :span="8">买家信息：{{ data.buyerOrgName }}</el-col>
        <el-col :span="8">结算编号：{{ data.settleOrderNo }}</el-col>
      </el-row>
      <el-row class="m-t15">
        <el-col :span="8">结算单创建时间：{{ data.gmtCreated | parseTime }}</el-col>
        <el-col :span="8"
          >结算单创建人：
          <span v-if="data.createUserId === 0">自动结算</span>
          <span v-else>{{ data.createUserName }}</span>
        </el-col>
      </el-row>
      <el-row class="m-t15">
        <el-col :span="8">结算单确认时间：{{ data.gmtConfirmed | parseTime }}</el-col>
        <el-col :span="8"
          >结算单确认人：
          <span v-if="data.gmtConfirmed">
            <span v-if="data.confirmUserId === 0">自动确认结算</span>
            <span v-else>
              {{ data.confirmUserName }}
              <i class="el-icon-s-comment c-hover f-16" @click="showIM(data.confirmUserId)"></i>
            </span>
          </span>
        </el-col>
      </el-row>
      <el-row class="m-t15">
        <el-col :span="8"
          >预实提差：<span class="c-hover">{{ data.weightDiff | formatWeightDiff }}</span></el-col
        >
        <el-col :span="8"
          >本次结算数量/重量：
          <span class="c-hover">{{ data.totalQuantity }}件/{{ data.totalWeight }}吨</span>
        </el-col>
        <el-col :span="8"
          >本次结算金额合计：<span class="c-hover">
            ¥{{ data.totalAmount | formatPermil }}</span
          ></el-col
        >
      </el-row>
    </div>
  </div>
</template>

<script>
import { download } from '@/common/utils/download'
import NP from 'number-precision'

export default {
  name: 'DetailHead',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  filters: {
    formatWeightDiff(weightDiff) {
      if (weightDiff > 0) {
        return `多提${NP.divide(weightDiff, 10000)}吨`
      } else if (weightDiff < 0) {
        return `少提${NP.divide(Math.abs(weightDiff), 10000)}吨`
      } else {
        return '--'
      }
    },
    convertStatus(status) {
      let text = ''
      if (status === 1) {
        text = '待结算确认'
      } else if (status === 2 || status === 3) {
        text = '已结算确认'
      }
      return text
    },
    convertStatusTag(status) {
      let text = 'color:#909399;'
      if (status === 1) {
        text = 'color:#e6a23c;'
      } else if (status === 2 || status === 3) {
        text = 'color:#67c23a;'
      }
      return text
    }
  },
  methods: {
    showIM(id) {
      const obj = id ? { sessionId: id } : null
      window.IM && window.IM.show(obj)
    },
    async exportDetail() {
      const request = { settleOrderNo: this.data.settleOrderNo }
      const { success, data } = await this.$post('settle.seller.exportSettleOrderItems', {
        request
      })
      if (success && data) {
        const { fileKey } = data[0]
        if (fileKey) {
          download(fileKey, fileKey)
        } else {
          this.$message.error('导出失败')
        }
      }
    }
  }
}
</script>
